import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { SubStringRezEnum } from '@/modules/ojeteVozy/constants';
import { PlatbaTyp } from '@/modules/uctenky/fakturace/constants';

import { apiProvider } from '../api';
import { CRUMB_LABEL_KEY as crumbLabel, NAME as name } from '../constants';
import { listMutations } from './types';

const filter = {
	ProvozovnaId: null as number | null,
	SkladVoz: null as boolean | null,
	KomisVoz: null as boolean | null,
	PovPzn: null as number | null,
	Pov2Pzn: null as number | null,
	DokladDruh: null as string | null,
	DokladPfx: null as string | null,
	DokladNr: null as number | null,
	PovNr: null as number | null,
	KomiseovNr: null as string | null,
	UzavreniDatOd: null as Date | null,
	UzavreniDatDo: null as Date | null,
	DuzpDatOd: null as Date | null,
	DuzpDatDo: null as Date | null,
	SplatnostDatOd: null as Date | null,
	SplatnostDatDo: null as Date | null,
	PlatbaPzn: null as PlatbaTyp | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	PrijmeniFirma: null as string | null,
	Ico: null as string | null,
	Dic: null as string | null,
	VyrobekvozOzn: null as string | null,
	VozidloId: null as number | null,
	VozidloIdText: null as string | null,
	Spz: null as string | null,
	SpzSubstr: null as SubStringRezEnum | null,
	Terminal: null as string | null,
	Eet: null as boolean | null,
	EetFik: null as number | null,
	EetBkp: null as number | null,
	EetCommunicStatusPznList: null as number[] | null,
};

export const store = listStoreBuilder({
	apiProvider,
	crumbLabel,
	dropdownList: {
		ProvozovnaId: [],
		DokladDruh: [],
		PovPzn: [],
		Pov2Pzn: [],
		VyrobekvozOzn: [],
		PlatbaPzn: [],
		EetCommunicStatusPznList: [],
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.VOZIDLO_SELECT_MAPPER](state, { data }) {
			state.filter.VozidloId = data.value;
			state.filter.VozidloIdText = data.text;
		},
		[listMutations.ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikIdText = data.text;
		},
	},
	filter,
	localState: {},
	name,
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
	rowDetail: null,
	tableSetting: {},
});
